import {
  BRAND_KIT_PREVIEW_TRANSCRIPTION_SEGMENTS,
  BRAND_KIT_SAMPLE_VIDEO_URL,
} from '@/constants/brand-kit-preview-transcription';
import { applyBrandKitPreviewLayout } from '@/lib/brand-kit/applyBrandKitPreviewLayout';
import {
  TEMPLATE_FILLER_PREVIEW_URL,
  applyTemplatePreviewFillers,
} from '@/lib/brand-kit/applyTemplatePreviewFillers';
import { hydrateBrandKitWorkspace } from '@/lib/brand-kit/hydrateBrandKitWorkspace';
import type { SubtitleEditorData, SubtitleEditorLogoData } from '@/components/SubtitleEditor';
import type { PostLayoutConfig } from '@/lib/layouts/types';

export const BRAND_KIT_CARD_PREVIEW_SECONDS = 3;
export const BRAND_KIT_CARD_SAMPLE_TITLE_PT = 'Como os melhores criadores crescem tão rápido';
export const BRAND_KIT_CARD_CDN_ORIGIN = 'https://cdn.autoclipper.live';

export interface BrandKitCardPreviewProps {
  videoUrl: string;
  startTime: number;
  endTime: number;
  postLayout: PostLayoutConfig | null;
  subtitleConfig: SubtitleEditorData & { fontUrl?: string | null };
  logoConfig: SubtitleEditorLogoData;
  transcriptionSegments: typeof BRAND_KIT_PREVIEW_TRANSCRIPTION_SEGMENTS;
  subtitlesEnabled: true;
  isVideoLocked: true;
}

function mediaUrl(path: string, mediaOrigin: 'local' | 'cdn'): string {
  if (mediaOrigin === 'local') return path;
  return `${BRAND_KIT_CARD_CDN_ORIGIN}${path}`;
}

export function buildBrandKitCardPreviewProps({
  data,
  mediaOrigin,
  sampleClipTitle = BRAND_KIT_CARD_SAMPLE_TITLE_PT,
  fontUrl = null,
}: {
  data: unknown;
  mediaOrigin: 'local' | 'cdn';
  sampleClipTitle?: string;
  fontUrl?: string | null;
}): BrandKitCardPreviewProps {
  const workspace = hydrateBrandKitWorkspace(data);
  const fillerUrl = mediaUrl(TEMPLATE_FILLER_PREVIEW_URL, mediaOrigin);
  const postLayout = applyBrandKitPreviewLayout(
    applyTemplatePreviewFillers(workspace.postLayout, { fillerUrl }),
    workspace.fieldBinds,
    sampleClipTitle,
  );

  return {
    videoUrl: mediaUrl(BRAND_KIT_SAMPLE_VIDEO_URL, mediaOrigin),
    startTime: 0,
    endTime: BRAND_KIT_CARD_PREVIEW_SECONDS,
    postLayout,
    subtitleConfig: {
      ...workspace.subtitle,
      ...(fontUrl ? { fontUrl } : {}),
    },
    logoConfig: workspace.logo,
    transcriptionSegments: BRAND_KIT_PREVIEW_TRANSCRIPTION_SEGMENTS,
    subtitlesEnabled: true,
    isVideoLocked: true,
  };
}
